export const GEN_HEALTH_APP_URL = 'https://gen-health.app'
export const PATIENT_LOGIN_URL = 'https://portal.healberry.com/login'
export const INTAKE_PATH = '/intake'
export const WELCOME_OFFER_URL = 'https://healberry.myaestheticrecord.com/online-booking'
